// extracted by mini-css-extract-plugin
export default {"hideTooltip":"H--z","fadeIn":"I--z","delay":"J--z","recommendedSizeTooltip":"K--z"};